module.exports = __webpack_public_path__ + "static/media/play1.d38c11c6.png";